let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("43uxI")).then(() => parcelRequire('1UoO4'));